module.exports = __webpack_public_path__ + "img/tt.a79c0be7.png";